var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.validTabs.length)?_c('div',{staticClass:"tab-component"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"nav nav-pills flex-column flex-sm-row d-flex flex-wrap"},_vm._l((_vm.validTabs),function(data,index){return _c('a',{key:index,class:data.class[0].toLowerCase().trim().includes('technical_user')
            ? 'text-sm-center nav-link newclass'
            : 'text-sm-center nav-link',attrs:{"href":("#" + (encodeURI(
            data.description
              .toLowerCase()
              .trim()
              .replaceAll(' ', '-')
          ).replaceAll('%', '')))}},[_vm._v("\n        "+_vm._s(data.name)+"\n      ")])}),0)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }